import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import common from '../../strings/common.json';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
  })
);
const SubmitButton = withStyles((theme: Theme) => ({
  root: {
    color: 'white',
    backgroundColor: '#7DA0CD',
    '&:hover': {
      backgroundColor: '#525d6b',
    },
  },
}))(Button);
const CancelButton = withStyles((theme: Theme) => ({
  root: {
    color: 'grey',
    backgroundColor: '#DEDEDE',
    '&:hover': {
      backgroundColor: '#a8a8a8',
    },
  },
}))(Button);

function DialogButtonsSite() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CancelButton type="reset" variant="contained">
        {common.buttonLabels.cancel}
      </CancelButton>

      <SubmitButton type="submit" variant="contained">
        {common.siteDialog.addTasks}
      </SubmitButton>
    </div>
  );
}

export default DialogButtonsSite;
